// Pure helpers for the Sync Account page.
import dayjs from 'dayjs';

export const SYNC_SOURCES = Object.freeze({ MASTER: 'master', MANAGER: 'manager' });

const BADGES = {
  synced: { label: 'Synced', tone: 'emerald' },
  pending: { label: 'Pending', tone: 'amber' },
  declined: { label: 'Declined', tone: 'rose' },
  cancelled: { label: 'Cancelled', tone: 'slate' },
};

/** @param {string} status - API history status. @returns {{label: string, tone: string}} */
export const statusBadge = (status) => BADGES[status] || { label: String(status || 'Unknown'), tone: 'slate' };

/** @returns {string} "11-01-2026 10:30 am", or "—" when there is no completion time. */
export const fmtCompletedAt = (d) => (d && dayjs(d).isValid() ? dayjs(d).format('MM-DD-YYYY h:mm a') : '—');

/** Row label for the "To" column when the API did not supply one. */
export function targetLabel(row) {
  if (row?.to) return row.to;
  return row?.sourceType === SYNC_SOURCES.MASTER ? 'CIVIX Master' : 'Team manager';
}
